import BN from "bn.js"
import {toWei} from 'web3-utils'

export const sleep = time => new Promise(res => setTimeout(res, time))

export const decimal = (number, exp) =>
{
  const decimals = new BN('10').pow(new BN( (18 - Number(exp)).toString()))
  number = new BN(toWei(number.toString())).div(decimals)
  return number.toString()
}
    // exp > 0 ? new BN(number).mul(new BN(10).pow(new BN(exp))).toString() : new BN(number).div(new BN(10).pow(new BN(exp))).toString()



// WEBPACK FOOTER //
// ./src/utils.js